"use strict";

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var layout_1 = require("../layout");

require("./form.less");

var CheckList = function (_super) {
  __extends(CheckList, _super);

  function CheckList(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      value: props.value || [],
      isValid: !!props.value
    };
    return _this;
  }

  Object.defineProperty(CheckList.prototype, "field", {
    get: function get() {
      return this.props.field;
    },
    enumerable: true,
    configurable: true
  });

  CheckList.prototype.onValue = function (value, selected) {
    var array = this.state.value;

    if (selected) {
      array.push(value);
    } else {
      array = array.filter(function (item) {
        return item !== value;
      });
    }

    var isValid = true;
    this.setState({
      value: array,
      isValid: isValid
    });
    var context = this.props.context;
    var field = this.props.field;
    context.onValue(field, array, isValid);
  };

  CheckList.prototype.componentWillReceiveProps = function (nextProps) {
    var value = nextProps.value || this.state.value;
    this.setState({
      value: value
    });
  };

  CheckList.prototype.render = function () {
    var _this = this;

    var label = "";

    if (this.props.label) {
      label = React.createElement("label", null, this.props.label);
    }

    var width = 12 / (this.props.columns || 1);
    var value = this.state.value;
    var childrenWithProps = React.Children.map(this.props.children, function (original, key) {
      var v = original["props"].value;
      var selected = value.indexOf(v) > -1;
      return React.cloneElement(original, {
        key: String(key),
        selected: selected,
        width: width,
        context: _this
      });
    });
    return React.createElement("div", {
      className: "input"
    }, label, React.createElement(layout_1.Row, {
      collapsed: true
    }, childrenWithProps));
  };

  return CheckList;
}(React.Component);

exports["default"] = CheckList;
var ON = "1";
var OFF = "0";

var CheckListItem = function (_super) {
  __extends(CheckListItem, _super);

  function CheckListItem(props) {
    var _this = _super.call(this, props) || this;

    var serial = String(Math.random()).substring(2, 10);
    var field = props.context.field;
    var id = props.id || field + "_" + serial;
    _this.state = {
      id: id,
      selected: props.selected
    };
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  CheckListItem.prototype.onChange = function (event) {
    var item = event.currentTarget;
    var selected = item.value === ON;
    this.setState({
      selected: !selected
    });
    var _a = this.props,
        context = _a.context,
        value = _a.value;
    context.onValue(value, !selected);
  };

  CheckListItem.prototype.componentWillReceiveProps = function (nextProps) {
    var selected = nextProps.selected;
    this.setState({
      selected: selected
    });
  };

  CheckListItem.prototype.render = function () {
    var text = this.props.text || String(this.props.value);
    var id = this.state.id;
    var selected = this.state.selected ? ON : OFF;
    return React.createElement(layout_1.Col, {
      xs: 12,
      sm: this.props.width
    }, this.props["switch"] ? React.createElement("div", {
      className: "input-checkbox input-checkbox--switch"
    }, React.createElement("span", {
      className: "input__label"
    }, !!this.props.children ? this.props.children : text), React.createElement("input", {
      type: "checkbox",
      id: id,
      name: this.props.value,
      value: selected,
      checked: this.state.selected,
      onChange: this.onChange
    }), React.createElement("label", {
      htmlFor: id
    })) : React.createElement("div", {
      className: "input-checkbox"
    }, React.createElement("span", {
      className: "input__label"
    }, !!this.props.children ? this.props.children : text), React.createElement("input", {
      type: "checkbox",
      id: id,
      name: this.props.value,
      value: selected,
      checked: this.state.selected,
      onChange: this.onChange
    }), React.createElement("label", {
      htmlFor: id
    })));
  };

  return CheckListItem;
}(React.Component);

exports.CheckListItem = CheckListItem;